import { type ChangeEvent, type MouseEvent } from 'react'

import style from './Filters.module.scss'
import Search from './search.svg'

interface IProps {
    insuranceCompanyId: string
    totalCount: number
    currentPage: number
    pageSize: number
    filter: string
    setFilter: React.Dispatch<React.SetStateAction<string>>
    onGetPolicyHoldersHandler: (id: string, page: number, filterValue: string) => void
}

export const Filters = (props: IProps) => {
    const { filter, setFilter, insuranceCompanyId, totalCount, currentPage, pageSize, onGetPolicyHoldersHandler } =
        props

    const paginationValue = `${currentPage} / ${Math.ceil(totalCount / pageSize)}`

    const isLastPage: boolean = currentPage === Math.ceil(totalCount / pageSize)
    const isFirstPage: boolean = currentPage === 1

    const onPageClickHandler = (e: MouseEvent<HTMLButtonElement>, type: 'next' | 'prev') => {
        e.stopPropagation()
        if (type === 'next') {
            onGetPolicyHoldersHandler(insuranceCompanyId, currentPage + 1, '')
            return
        }
        if (type === 'prev') {
            onGetPolicyHoldersHandler(insuranceCompanyId, currentPage - 1, '')
        }
    }

    const onChangeSearchHandler = (e: ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value)
        if (!e.target.value) {
            onGetPolicyHoldersHandler(insuranceCompanyId, 1, e.target.value)
        }
    }

    return (
        <div className={style.container}>
            <div className={style.search}>
                <input
                    type='text'
                    placeholder='Поиск'
                    value={filter}
                    onChange={onChangeSearchHandler}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            onGetPolicyHoldersHandler(insuranceCompanyId, 1, filter)
                        }
                    }}
                />
                {filter && (
                    <div
                        className={style.searchWrapper}
                        onClick={() => onGetPolicyHoldersHandler(insuranceCompanyId, 1, filter)}
                    >
                        <Search />
                    </div>
                )}
            </div>
            <div className={style.pages}>
                <button
                    onClick={(e: MouseEvent<HTMLButtonElement>) => onPageClickHandler(e, 'prev')}
                    title={'Пред. Страница'}
                    disabled={isFirstPage}
                >
                    {'<'}
                </button>

                <div>
                    <span>{paginationValue}</span>
                </div>
                <button
                    onClick={(e: MouseEvent<HTMLButtonElement>) => onPageClickHandler(e, 'next')}
                    title={'Сл. Страница'}
                    disabled={isLastPage}
                >
                    {'>'}
                </button>
            </div>
            <div className={style.refresh}>
                <button
                    onClick={() => {
                        setFilter('')
                        onGetPolicyHoldersHandler(insuranceCompanyId, 1, '')
                    }}
                    title={'Сброс на первую страницу с занулением поля поиска'}
                >
                    {'Сброс фильтрации'}
                </button>
            </div>
        </div>
    )
}
